var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { style: _vm.css_props, attrs: { id: "main" } },
    [
      _c(
        "v-row",
        { staticClass: "main__container", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { ref: "display_block", staticClass: "display-block__wrapper" },
            [
              _c("DisplayBlock", {
                attrs: { is_show_favorites: _vm.is_show_favorites }
              }),
              _vm._v(" "),
              _c("Notifications", {
                attrs: { system_information: _vm.information }
              }),
              _vm._v(" "),
              _c("ToggleMenuBtn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.is_hide_menu,
                    expression: "is_hide_menu"
                  }
                ],
                staticClass: "main-block-options__btn__menu--mobile",
                attrs: { is_hide_menu: _vm.is_hide_menu },
                on: {
                  "update:is_hide_menu": function($event) {
                    _vm.is_hide_menu = $event
                  },
                  trigger_menu_display: _vm.toggle_menu
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "main-block-options__background",
              class: {
                "main-block-options__background--other":
                  this.last_selected_main_menu !== "emap",
                "main-block-options__background--map-monitor":
                  _vm.is_monitor_open_emap,
                "main-block-options__content--hide_menu": _vm.is_hide_menu
              }
            },
            [
              _c(
                "div",
                { staticClass: "main-block-options__content" },
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        justify: "center",
                        "align-content": "space-around",
                        "no-gutters": ""
                      }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "main-block-options__btn main-block-options__btn__menu",
                          attrs: { cols: "12" }
                        },
                        [
                          _c("ToggleMenuBtn", {
                            attrs: { is_hide_menu: _vm.is_hide_menu },
                            on: {
                              "update:is_hide_menu": function($event) {
                                _vm.is_hide_menu = $event
                              },
                              trigger_menu_display: _vm.toggle_menu
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.main_menu, function(menu, index) {
                        return _c(
                          "v-col",
                          {
                            key: index,
                            staticClass:
                              "main-block-options__btn main-block-options__btn__block",
                            class: {
                              "main-block-options__btn__block--active":
                                _vm.selected_main_menu === menu.name
                            },
                            attrs: { cols: "12" }
                          },
                          [
                            menu.tooltip_text
                              ? _c("QpeTooltip", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "hovered_item",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "menu-btn",
                                                class: {
                                                  active:
                                                    _vm.selected_main_menu ===
                                                    menu.name,
                                                  unactive:
                                                    _vm.selected_main_menu !==
                                                    menu.name
                                                },
                                                on: { click: menu.func }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { size: "32" } },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(menu.icon) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(menu.text))
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      },
                                      {
                                        key: "tooltip_content",
                                        fn: function() {
                                          return [
                                            _c("span", [
                                              _vm._v(_vm._s(menu.tooltip_text))
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "menu-btn",
                                    class: {
                                      active:
                                        _vm.selected_main_menu === menu.name,
                                      unactive:
                                        _vm.selected_main_menu !== menu.name
                                    },
                                    on: { click: menu.func }
                                  },
                                  [
                                    _c("v-icon", { attrs: { size: "32" } }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(menu.icon) +
                                          "\n                            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(menu.text))])
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.is_hide_previous_btn
                        ? _c(
                            "v-col",
                            {
                              staticClass:
                                "main-block-options__btn main-block-options__btn__block",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "menu-btn",
                                  attrs: {
                                    href: "/" + _vm.previous_client_name,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { size: "32" } }, [
                                    _vm._v(
                                      "\n                                mdi-launch\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("__menu.previous")))
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "aside",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.is_hide_menu,
                  expression: "!is_hide_menu"
                }
              ],
              staticClass: "main-menu__container"
            },
            [
              _c("MainMenu", {
                ref: "main_menu",
                attrs: {
                  atlas_menu_data: _vm.atlas_menu_data,
                  selected_main_menu: _vm.selected_main_menu
                },
                on: { "transfer-information": _vm.transfer_information }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c("FullpageHint", {
            attrs: {
              title:
                "系統因需進行硬體更新，預計於 12:00~12:30 進行維修(尚須接資料)",
              content: "屆時用戶無法使用，請及早因應，造成不便敬請見諒",
              is_show_confirm_btn: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.is_mobile_landscape
        ? _c("FullpageHint", {
            attrs: {
              title: _vm.$t("__fullpage_hint.landscape_title"),
              content: _vm.$t("__fullpage_hint.landscape_content"),
              is_show_confirm_btn: true
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }